import Head from 'next/head'
import * as React from 'react'
import { HubspotHeadComponent } from './HubspotHeadComponent'
import { ISchool } from '../interfaces/school.interface'
import { MicrosoftClaritySchoolHeadComponent } from './MicrosoftClaritySchoolHeadComponent'

export default function SchoolUserPageHead(props: { schoolDetails: ISchool }) {
  return (
    <Head>
      <title>
        {props.schoolDetails &&
          props.schoolDetails?.school_url !== 'pledre' &&
          `${props.schoolDetails?.name} - ${props.schoolDetails?.tagline}`}
      </title>
      <meta name="name" content={props.schoolDetails?.name} />
      <meta name="description" content={props.schoolDetails?.tagline} />
      <meta name="tagline" content={props.schoolDetails?.tagline} />
      <link rel="shortcut icon" href={props.schoolDetails?.logo} />
      <meta property="og:title" content={props.schoolDetails?.name} />
      <meta
        property="og:url"
        content={`${
          props.schoolDetails ? props.schoolDetails?.school_url : ''
        }.pledre.school`}
      />
      <meta property="og:image" content={props.schoolDetails?.logo} />
      <meta
        property="og:image:secure_url"
        content={props.schoolDetails?.logo}
      />

      <style>
        {`
          body{
             background-color: #fff !important;
          }
          `}
      </style>
      <HubspotHeadComponent />
      <MicrosoftClaritySchoolHeadComponent />
    </Head>
  )
}
